import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "appointment-treatment-selector mx-auto w-full max-w-screen-md flex flex-col"
}
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "d-flex justify-start gap-2 flex-row-reverse w-4/12" }
const _hoisted_4 = { class: "overflow-y-scroll flex-grow pa-2 pt-4" }
const _hoisted_5 = { class: "notes-module-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-center text-button mb-4 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientListItem = _resolveComponent("PatientListItem")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_TreatmentsTabContent = _resolveComponent("TreatmentsTabContent")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_AppointmentsList = _resolveComponent("AppointmentsList")!
  const _component_TreatmentNotesCard = _resolveComponent("TreatmentNotesCard")!
  const _component_AddNewNote = _resolveComponent("AddNewNote")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_WarningConfirmDialog = _resolveComponent("WarningConfirmDialog")!

  return (_ctx.appointment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_PatientListItem, {
            initialsItem: _ctx.appointment.doctor,
            initialsItemDoctors: _ctx.appointment.doctors,
            "image-url": _ctx.appointment.patient.avatar,
            title: _ctx.appointment.patient.name,
            timestamp: _ctx.appointment.starts_at,
            "no-padding": ""
          }, null, 8, ["initialsItem", "initialsItemDoctors", "image-url", "title", "timestamp"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              class: "py-2 px-2",
              color: "gray-50",
              icon: "mdi-close",
              density: "comfortable",
              variant: "text",
              onClick: _ctx.closeModal
            }, null, 8, ["onClick"]),
            (_ctx.canCheckOut && _ctx.interactWithBoard)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  color: "primary",
                  onClick: _ctx.showConfirmation
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" CHECK OUT ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]))
              : (_ctx.candidateToManual && _ctx.interactWithBoard)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 1,
                    color: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showManualWarningFor(_ctx.manualCheckIn)))
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" MANUAL CHECK-IN ", -1)
                    ]))]),
                    _: 1
                  }))
                : (_ctx.canReturnBackToUpcoming && _ctx.interactWithBoard)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 2,
                      color: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showManualWarningFor(_ctx.returnToUpcoming)))
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" RETURN TO UPCOMING ", -1)
                      ]))]),
                      _: 1
                    }))
                  : (_ctx.canReturnToArrived && _ctx.interactWithBoard)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 3,
                        color: "primary",
                        onClick: _ctx.checkInBack
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" CHECK BACK IN ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_v_sheet, { class: "bg-white rounded" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event)),
              color: "primary",
              "hide-slider": ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "treatments" }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Treatments", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "appointments" }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Appointments", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "notes" }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("Notes", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_tabs_window, {
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeTab) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs_window_item, {
                  value: "treatments",
                  style: {"height":"650px","overflow-y":"scroll"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TreatmentsTabContent, {
                      treatments: _ctx.treatments,
                      "treatments-doctors": _ctx.treatmentsDoctors,
                      "appt-treatment-list": _ctx.apptTreatmentList,
                      "completed-treatments": _ctx.completedTreatments,
                      "interact-with-board": _ctx.interactWithBoard,
                      "today-and-not-completed": _ctx.todayAndNotCompleted,
                      "show-draggable": _ctx.showDraggable,
                      "can-apply-last-appointment": _ctx.canApplyLastAppointment,
                      "can-clear-appointment": _ctx.canClearAppointment,
                      "is-processing": _ctx.isProcessing,
                      "telehealth-room": _ctx.telehealthRoom,
                      "link-copied": _ctx.telehealthLinkCopied,
                      onCardDefaultClick: _ctx.onCardDefaultClicked,
                      onSelectTreatment: _ctx.handleSelectTreatment,
                      onRemoveTreatment: _ctx.onTreatmentRemoveClicked,
                      onApplyLastAppointment: _ctx.applyLastAppointment,
                      onClearAppointment: _ctx.handleClearAppointment,
                      onCopyLink: _ctx.copyTelehealthLink,
                      onDragStart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dragging = true)),
                      onDragEnd: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dragging = false))
                    }, null, 8, ["treatments", "treatments-doctors", "appt-treatment-list", "completed-treatments", "interact-with-board", "today-and-not-completed", "show-draggable", "can-apply-last-appointment", "can-clear-appointment", "is-processing", "telehealth-room", "link-copied", "onCardDefaultClick", "onSelectTreatment", "onRemoveTreatment", "onApplyLastAppointment", "onClearAppointment", "onCopyLink"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, {
                  value: "appointments",
                  style: {"height":"650px","overflow-y":"scroll"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AppointmentsList)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tabs_window_item, {
                  value: "notes",
                  style: {"height":"650px","overflow-y":"scroll"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        (!!_ctx.notes)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (noteArray, treatment) => {
                                return (_openBlock(), _createBlock(_component_TreatmentNotesCard, {
                                  key: `${treatment}-notes`,
                                  notes: noteArray,
                                  "appointment-id": _ctx.appointment.uuid,
                                  "patient-id": _ctx.appointment.patient.uuid,
                                  "patient-name": _ctx.appointment.patient.name,
                                  "treatment-id": String(treatment),
                                  "hide-patient": true,
                                  "is-appointment-dialog": "",
                                  onRefreshNotes: _ctx.refreshNotes,
                                  onSetAllowedClose: _ctx.setAllowedToClose
                                }, null, 8, ["notes", "appointment-id", "patient-id", "patient-name", "treatment-id", "onRefreshNotes", "onSetAllowedClose"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_AddNewNote, {
                            "appointment-id": _ctx.appointment.uuid,
                            "patient-id": _ctx.appointment.patient.uuid,
                            "hide-header-text": !!_ctx.notes,
                            onRefreshNotes: _ctx.refreshNotes,
                            onSetAllowedClose: _ctx.setAllowedToClose
                          }, null, 8, ["appointment-id", "patient-id", "hide-header-text", "onRefreshNotes", "onSetAllowedClose"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_WarningConfirmDialog, {
          modelValue: _ctx.showManualWarning,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showManualWarning) = $event)),
          message: "This is an emergency-only action. Use only when DrChrono sync is down.",
          onConfirm: _ctx.onManualWarningConfirmed
        }, null, 8, ["modelValue", "onConfirm"])
      ]))
    : _createCommentVNode("", true)
}